import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import Layout from './components/Layout/Layout';
import { VersionGuard } from './components/VersionGuard';
import { VersionRedirect } from './components/VersionRedirect';
import ApiDocs from './pages/api-reference/ApiDocs';
import { Authentication } from './pages/authentication';
import { Constants } from './pages/constants';
import { Outputs } from './pages/outputs';
import { Package } from './pages/package';
import { SDK } from './pages/sdk';
import { Vegetation } from './pages/vegetation';
import { Welcome } from './pages/welcome';
import { hasNpmPackage } from './versions/npm-package';
import { hasPreV4Pages } from './versions/pre-v4-pages';
import { docSlug } from './versions/versions';
import { MAX_DOCS_VERSION } from './versions/visible-versions';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to={`/api/${docSlug(MAX_DOCS_VERSION)}`} replace />,
  },
  {
    // 4.0.2 was published under its real version before it moved to the 4.0-beta slug
    path: '/api/4.0.2/*',
    element: <VersionRedirect to="4.0-beta" />,
  },
  {
    path: '/api/:version',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to="welcome" replace />,
      },
      {
        path: 'welcome',
        index: true,
        element: <Welcome />,
      },
      {
        path: 'authentication',
        element: <Authentication />,
      },
      {
        path: 'api-reference',
        element: <ApiDocs />,
      },
      {
        path: 'api-reference/:calculator',
        element: <ApiDocs />,
      },
      {
        path: 'constants',
        element: <Constants />,
      },
      {
        path: 'vegetation',
        element: (
          <VersionGuard supports={hasPreV4Pages}>
            <Vegetation />
          </VersionGuard>
        ),
      },
      {
        path: 'package',
        element: (
          <VersionGuard supports={hasNpmPackage}>
            <Package />
          </VersionGuard>
        ),
      },
      {
        path: 'sdk',
        element: (
          <VersionGuard supports={hasNpmPackage}>
            <SDK />
          </VersionGuard>
        ),
      },
      {
        path: 'outputs',
        element: (
          <VersionGuard supports={hasPreV4Pages}>
            <Outputs />
          </VersionGuard>
        ),
      },
      {
        // Any page that doesn't exist for this version, e.g. after switching versions
        path: '*',
        element: <VersionGuard />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
